enum CharacterCode {
  /** ISO 8859-1 */
  iso88591 = 'ISO_8859-1',
  /** 日本語(Windows-31J) */
  ms932 = 'MS932',
  /** UTF-16 */
  utf16 = 'UTF-16',
  /** UTF-8 */
  utf8 = 'UTF-8',
}
const characterCodeMap = new Map([
  ['ISO 8859-1', CharacterCode.iso88591],
  ['MS932', CharacterCode.ms932],
  ['UTF-16', CharacterCode.utf16],
  ['UTF-8', CharacterCode.utf8],
]);

export { CharacterCode, characterCodeMap };
